// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3k81q","resendInfoText":"OnGoingPaymentBox_resendInfoText__2OeIr"};